import { createWeModApi } from '@repo/wemod-api/base';
import type { FeatureFlags } from '@repo/wemod-api/features/schema';

export interface RequestFeatureFlagsOptions {
    bearerToken?: string | null;
}

export async function requestFeatureFlags(options: RequestFeatureFlagsOptions = {}): Promise<FeatureFlags> {
    const api = createWeModApi({
        baseUrl: process.env.NEXT_PUBLIC_WEMOD_API_URL ?? '',
        getAuthToken: () => options.bearerToken ?? null,
    });

    const { data, error } = await api.features.get();
    if (error !== null) {
        throw new Error(`Feature flags request failed: ${error || 'request failed'}`);
    }

    return data;
}
